import MediaCard from 'components/cards/new/common/MediaCard'

const WhyTrustW4B = () => {
  return (
    <MediaCard
      image={{
        alt: 'WhatsApp notifications illustration',
        desktop: {
          dimensions: {
            height: 580,
            width: 513,
          },
          src: '/images/new/whatsapp/wa-notificaitons.png',
        },
        mobile: {
          dimensions: {
            height: 560,
            width: 542,
          },
          src: '/images/new/whatsapp/wa-notifications-mobile.png',
        },
      }}
      layout={{
        desktop: 'content-right-media-left',
        mobile: 'content-top-media-bottom',
      }}
      imageFitPreset='cover-right'
      imageContainerWidth='32%'
    >
      <div className='d-flex flex-1 flex-column gap-3 px-4 pt-8 py-lg-17 pe-lg-10'>
        <h2 className='fs-fluid-36-48 lh-108 fw-semibold mb-2'>
          Why trust <strong>WhatsApp for Business?</strong>
        </h2>
        <p className='fs-fluid-18-22 fw-semibold mb-0 lh-132 me-lg-15'>
          WhatsApp for Business connects you instantly with a global audience,
          over 3 billion users worldwide, including 38 million in the UK.
        </p>
        <p className='fs-fluid-18-22 fw-semibold mb-0 lh-132 me-lg-15'>
          Calls and messages use your internet connection, so they're
          effectively free when you're on Wi-Fi or mobile data. Your business
          number works globally, letting you manage sales and customer support
          wherever you go.
        </p>
        <p className='fs-fluid-18-22 fw-semibold mb-0 lh-132 me-lg-15'>
          WhatsApp continues to release new features and free updates. The
          Hoxton Mix will keep you informed about every improvement to the
          WhatsApp Business platform so your communications stay ahead.
        </p>
      </div>
    </MediaCard>
  )
}

export default WhyTrustW4B
